module.exports = __webpack_public_path__ + "img/banner_wx.0a77d544.png";